import { render, staticRenderFns } from "./addIpcShopping.vue?vue&type=template&id=8393941e&scoped=true&"
import script from "./addIpcShopping.vue?vue&type=script&lang=js&"
export * from "./addIpcShopping.vue?vue&type=script&lang=js&"
import style0 from "./addIpcShopping.vue?vue&type=style&index=0&id=8393941e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8393941e",
  null
  
)

export default component.exports